<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="cancel()" />
</div>

<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <ion-col>
        <h2>Administrer</h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="375"
          height="2"
          viewBox="0 0 375 2"
          fill="none"
        >
          <path d="M375 1H0" stroke="#D8D8D8" />
        </svg>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
      </ion-col>
    </ion-row>
    <ion-row class="mb-8">
      <ion-col>
        <h2>Mine biler</h2>
        <div *ngIf="vehicles">
          <div
            *ngFor="let vehicle of vehicles"
            class="car-container"
            [class.selected-row]="vehicle.id === selectedVehicleId"
          >
            <p class="text-left">
              {{
                vehicle.vendor +
                  ' ' +
                  vehicle.information.model +
                  ' (' +
                  vehicle.information.year +
                  ')'
              }}
            </p>
            <ion-button
              *ngIf="vehicle.id === selectedVehicleId"
              class="green radius-full"
            >
              Valgt
            </ion-button>
            <ion-button
              *ngIf="vehicle.id !== selectedVehicleId"
              class="radius-full"
              (click)="selectVehicle(vehicle)"
            >
              Velg
            </ion-button>
          </div>
        </div>
        <ion-button class="dark" (click)="linkVehicle()"
          ><ion-icon name="add" class="add-icon"></ion-icon> Legg til ny bil
        </ion-button>
        <div class="flex items-center justify-center">
          <ion-icon name="trash"></ion-icon>
          <p class="more" (click)="openUnlikModal()">
             Fjern bil fra appen
          </p>
        </div>
        <ion-modal
          [isOpen]="showUnlinkModal"
          [backdropDismiss]="true"
          cssClass="unlink-vendor-modal-content"
          (didDismiss)="showUnlinkModal = false"
          (willDismiss)="canDismissUnlink($event)"
        >
          <ng-template>
            <app-unlink-vendor-modal
              [vehicles]="vehicles"
            ></app-unlink-vendor-modal>
          </ng-template>
        </ion-modal>
      </ion-col>
    </ion-row>
    <ion-row class="mb-8">
      <ion-col>
        <h2>Mine adresser</h2>
        <div *ngIf="locations">
          <div
            *ngFor="let location of locationAddresses"
            class="location-container"
          >
            <div class="flex-icon">
              <ion-icon class="location-icon" name="location"></ion-icon>
              <div class="text-left p-2 location-name">
                <p class="bold">{{ location.name }}</p>
                <p
                  class="smalltext"
                  (click)="showChargingLocationModal(location)"
                >
                  Se lokasjon i kart
                </p>
              </div>
            </div>
            <ion-modal
              [isOpen]="showChargingLocationId === location.id"
              [backdropDismiss]="true"
              cssClass="show-charging-location-modal-content"
              (didDismiss)="showChargingLocationId = undefined"
            >
              <ng-template>
                <app-show-charging-location-modal [chargingLocation]="location">
                </app-show-charging-location-modal>
              </ng-template>
            </ion-modal>
            <!-- <ion-button disabled class="radius-full"> Endre </ion-button> -->
            <ion-button
              class="radius-full"
              (click)="deleteLocation(location.id)"
            >
              <ion-icon name="trash"></ion-icon>
            </ion-button>
          </div>
        </div>
        <div *ngIf="locations?.length === 0">
          <p class="pi-2">
            Det ser ikke ut som du har lagt til noen adresser. For å kunne
            benytte smartlading må du legge til minst én adresse.
          </p>
        </div>
        <ion-button class="dark" (click)="showLocationModal()"
          ><ion-icon name="add" class="add-icon"></ion-icon> Legg til ny
          adresse
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p class="more" (click)="showSmartChargeInfo = true">
          <ion-icon name="information-circle"></ion-icon> Informasjon om
          smartlading
        </p>
        <ion-modal
          [isOpen]="showSmartChargeInfo"
          [backdropDismiss]="true"
          cssClass="show-charging-location-modal-content"
          (didDismiss)="showSmartChargeInfo = false"
        >
          <ng-template>
            <app-smart-charge-info-modal></app-smart-charge-info-modal>
          </ng-template>
        </ion-modal>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
